import React from 'react';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import useProjectNotesService from '../useProjectNotesService';
import { FormFieldsData, UpdateForm } from 'framework/form';
import ProjectCloseoutForm from './ProjectCloseoutForm';
import { useShowContext } from 'framework/show';

interface ProjectCloseoutFormProps {
  projectCloseout: () => Promise<object>;
  onCancel: () => void;
  afterSubmit?: { execute?: (data: any) => void };
  messageContext?: string;
}

const UpdateCloseout = ({ projectCloseout, onCancel, ...props }: ProjectCloseoutFormProps) => {
  const { data: entity } = useShowContext();
  const { updateCloseout, getCloseoutValidationSchema } = useProjectNotesService();

  const submitFormFunc = (id: StringOrNumber, values: FormFieldsData) => {
    const payload = {
      status: values.status,
      totalHoursSpent: values.totalHoursSpent,
      deliveryDate: values.deliveryDate,
      links: values.links,
      text: values.text,
    };
    return updateCloseout(values.id, payload);
  };

  const getDataForForm = async () => {
    if (entity && entity.payload) {
      return {
        id: entity.id,
        ...entity,
        ...entity.payload,
      };
    }

    return {};
  };

  return (
    <UpdateForm
      getDataFunc={getDataForForm}
      submitFormFunc={submitFormFunc}
      getValidationSchemaFunc={getCloseoutValidationSchema}
      {...props}
    >
      <BaseTimelineItemFormLayout onCancel={onCancel}>
        <ProjectCloseoutForm />
      </BaseTimelineItemFormLayout>
    </UpdateForm>
  );
};

export default UpdateCloseout;
